import signedFetch from './util/signedFetch.js';

export const getUserQueueByBatchId = (orgId, batchId) =>
  `${__API_BASE__}/ngs/user-queue/${orgId}/batch/${encodeURIComponent(batchId)}`;

export default function* getUserQueueApi(orgId, batchId) {
  return yield signedFetch('getUserQueueApi', getUserQueueByBatchId(orgId, batchId), 'GET');
}
